// Can't import from pro package - hence duplication
export const GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/constants/gridDetailPanelToggleField.js
// module id = 636
// module chunks = 25